import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function getRegions(config) {
    return httpUtils.get(`${env.API_VERSION}/region`, config);
}

export async function getCountries(config) {
    return httpUtils.get(`${env.API_VERSION}/country`, config);
}

export async function getCountriesByRegion(regionId, config) {
    const configWithParams = {
        ...config,
        params: {
            ...config?.params,
            region_id: regionId
        }
    };
    return httpUtils.get(`${env.API_VERSION}/country`, configWithParams);
}

export async function getCitiesByCountry(countryId, config) {
    return httpUtils.get(`${env.API_VERSION}/city/by-country/${countryId}`, config);
}

export async function searchUnicorn(config) {
    return httpUtils.get(`${env.API_VERSION}/search-startup`, config);
}

export async function facetUnicorn(config) {
    return httpUtils.get(`${env.API_VERSION}/facet-startup`, config);
}


export async function getWorldBankDataByRegion(regionId, config) {
    return httpUtils.get(`${env.API_VERSION}/world-bank/by-region/${regionId}`, config);
}

export async function getWorldBankDataByUnicornRegion(regionId, config) {
    return httpUtils.get(`${env.API_VERSION}/world-bank/by-unicorn-region/${regionId}`, config);
}

export async function getWorldBankDataByCountry(countryId, config) {
    return httpUtils.get(`${env.API_VERSION}/world-bank/by-country/${countryId}`, config);
}

export async function getUnicornStatisticByCountry(countryId, config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-statistic-by-country/${countryId}`, config);
}

export async function getUnicornStatisticByRegion(regionId, config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-statistic-by-region/${regionId}`, config);
}

export async function getSectors(config) {
    return httpUtils.get(`${env.API_VERSION}/industry`, config);
}

export async function getCities(config) {
    return httpUtils.get(`${env.API_VERSION}/city`, config);
}

// Specialized Analytics Endpoints
export async function getUnicornAnalyticsByDate(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-analytics-by-date`, config);
}

export async function getUnicornTimeSeries(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-time-series`, config);
}

export async function getUnicornSectorAnalytics(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-sector-analytics`, config);
}

export async function getUnicornRankings(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-rankings`, config);
}

export async function getUnicornComparisonByRegion(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-comparison-by-region`, config);
}

export async function getUnicornTotalFunding(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-total-funding`, config);
}

export async function getLostUnicorn(config) {
    return httpUtils.get(`${env.API_VERSION}/lost-unicorn`, config);
}

export async function getMedianTimeToUnicorn(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/median-time-to-unicorn`, config);
}

export async function getTotalValuation(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/total-valuation`, config);
}

export async function getUnicornStatsByRegion(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-stats-by-region`, config);
}

export async function getUnicornStatsByCountry(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-stats-by-country`, config);
}

export async function getUnicornBirthingStatsByCountry(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-birthing-stats-by-country`, config);
}

export async function getUnicornOriginBreakdownByCountry(countryId, config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-origin-breakdown-by-country/${countryId}`, config);
}

export async function getCountryById(countryId, config) {
    return httpUtils.get(`${env.API_VERSION}/country/by-id/${countryId}`, config);
}

export async function getRegionById(regionId, config) {
    return httpUtils.get(`${env.API_VERSION}/region/${regionId}`, config);
}

export async function getCountriesByRegionId(regionId, config) {
    return httpUtils.get(`${env.API_VERSION}/region/${regionId}/countries`, config);
}

export async function getUnicornStatisticsAllRegions(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-statistic-all-region`, config);
}

// ========================================
// NEW UNICORN REGION API ENDPOINTS
// ========================================

// Dropdown & Master Data
export async function getUnicornRegions(config) {
    return httpUtils.get(`${env.API_VERSION}/unicorn-region`, config);
}

export async function getUnicornRegionCountries(unicornRegionId, config) {
    return httpUtils.get(`${env.API_VERSION}/unicorn-region/${unicornRegionId}/countries`, config);
}

// Statistics & Analytics
export async function getUnicornStatisticAllUnicornRegion(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-statistic-all-unicorn-region`, config);
}

export async function getUnicornComparisonByUnicornRegion(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-comparison-by-unicorn-region`, config);
}

export async function getUnicornStatsByUnicornRegion(config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-stats-by-unicorn-region`, config);
}

export async function getUnicornStatisticByUnicornRegion(unicornRegionId, config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorn-statistic-by-unicorn-region/${unicornRegionId}`, config);
}

export async function getUnicornsByCity(countryId, config) {
    return httpUtils.get(`${env.API_VERSION}/startup/unicorns-by-city/${countryId}`, config);
}

export async function getCurrentUnicornsByCity(countryId, config) {
    return httpUtils.get(`${env.API_VERSION}/startup/current-unicorns-by-city/${countryId}`, config);
}

export async function getStartupCount(config) {
    return httpUtils.get(`${env.API_VERSION}/count-startup`, config);
}

export async function getUnicornStatusCounts(config) {
    return httpUtils.get(`${env.API_VERSION}/unicorn-status-counts`, config);
}

// Intro / Landing Page
export async function getUnicornIntroPage(config) {
    return httpUtils.get(`${env.API_VERSION}/unicorn-tracker/intro-page`, config);
}
